export default "__VITE_ASSET__DndZMTMM__"